import jsPDF from "jspdf";
import QRCode from "qrcode";

// ==========================================================
// Terbilang - Indonesian number to words
// ==========================================================
const _ANGKA = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"];
function _terbilang(n) {
  n = Math.floor(Math.abs(Number(n) || 0));
  if (n < 12) return _ANGKA[n];
  if (n < 20) return _terbilang(n - 10) + " Belas";
  if (n < 100) return _terbilang(Math.floor(n / 10)) + " Puluh" + (n % 10 ? " " + _terbilang(n % 10) : "");
  if (n < 200) return "Seratus" + (n - 100 ? " " + _terbilang(n - 100) : "");
  if (n < 1000) return _terbilang(Math.floor(n / 100)) + " Ratus" + (n % 100 ? " " + _terbilang(n % 100) : "");
  if (n < 2000) return "Seribu" + (n - 1000 ? " " + _terbilang(n - 1000) : "");
  if (n < 1000000) return _terbilang(Math.floor(n / 1000)) + " Ribu" + (n % 1000 ? " " + _terbilang(n % 1000) : "");
  if (n < 1000000000) return _terbilang(Math.floor(n / 1000000)) + " Juta" + (n % 1000000 ? " " + _terbilang(n % 1000000) : "");
  if (n < 1000000000000) return _terbilang(Math.floor(n / 1000000000)) + " Milyar" + (n % 1000000000 ? " " + _terbilang(n % 1000000000) : "");
  return "";
}
export function terbilang(n) {
  const s = _terbilang(n).trim();
  return s ? `${s} Rupiah` : "Nol Rupiah";
}

const fmtIDR = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");
const fmtDate = (d) => d ? new Date(d).toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" }) : "-";

// ==========================================================
// Modern Kwitansi (A5 landscape) - simple + modern
// ==========================================================
export async function generateReceiptPDF({ payment, siswa, lembaga, nomenklatur, settings, tagihan_sisa }) {
  // A5 landscape = 210 x 148 mm
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a5" });
  const W = 210, H = 148;

  // === TEAL side panel (left accent) ===
  doc.setFillColor(11, 141, 149); // #0B8D95
  doc.rect(0, 0, 7, H, "F");

  // === Header ===
  doc.setTextColor(11, 141, 149);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text((settings?.foundation_short_name || settings?.foundation_name || "EduFoundation").toUpperCase(), 14, 12);
  doc.setFontSize(7);
  doc.setTextColor(120, 120, 120);
  doc.setFont("helvetica", "normal");
  doc.text(settings?.foundation_name || "Yayasan EduFoundation", 14, 16);
  if (settings?.address) doc.text(String(settings.address).slice(0, 60), 14, 19.5);
  if (settings?.phone || settings?.email) {
    doc.text(`${settings.phone || ""}${settings.phone && settings.email ? " · " : ""}${settings.email || ""}`, 14, 23);
  }

  // === Big KWITANSI badge (right) ===
  doc.setFillColor(11, 141, 149);
  doc.roundedRect(W - 62, 8, 50, 17, 2, 2, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text("KWITANSI", W - 37, 15, { align: "center" });
  doc.setFontSize(6.5);
  doc.setFont("helvetica", "normal");
  doc.text("BUKTI PEMBAYARAN", W - 37, 19, { align: "center" });
  doc.setFontSize(8);
  doc.setFont("helvetica", "bold");
  doc.text(payment.receipt_no || "-", W - 37, 23, { align: "center" });

  // Divider
  doc.setDrawColor(230, 230, 230);
  doc.setLineWidth(0.3);
  doc.line(14, 30, W - 12, 30);

  // === Info Rows (2 columns) ===
  doc.setTextColor(90, 90, 90);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.5);
  const LEFT_LABEL_X = 14, LEFT_VAL_X = 44;
  const RIGHT_LABEL_X = 112, RIGHT_VAL_X = 145;
  let y = 37;

  const rows = [
    ["Diterima dari", siswa?.name || "-", "Tanggal", fmtDate(payment.payment_date)],
    ["NIS / NISN", `${siswa?.nis || "-"}${siswa?.nisn ? " / " + siswa.nisn : ""}`, "Metode", (payment.method || "-").toUpperCase()],
    ["Kelas", siswa?.class_name || "-", "Lembaga", lembaga?.name || "-"],
  ];
  rows.forEach(([l1, v1, l2, v2]) => {
    doc.setTextColor(140, 140, 140);
    doc.setFont("helvetica", "normal");
    doc.text(l1, LEFT_LABEL_X, y);
    doc.text(l2, RIGHT_LABEL_X, y);
    doc.setTextColor(30, 30, 30);
    doc.setFont("helvetica", "bold");
    doc.text(String(v1), LEFT_VAL_X, y);
    doc.text(String(v2), RIGHT_VAL_X, y);
    y += 5.5;
  });

  // Wali murid if present
  if (siswa?.parent_name || siswa?.parent_phone) {
    doc.setTextColor(140, 140, 140);
    doc.setFont("helvetica", "normal");
    doc.text("Wali", LEFT_LABEL_X, y);
    doc.setTextColor(30, 30, 30);
    doc.setFont("helvetica", "bold");
    doc.text(`${siswa.parent_name || "-"}${siswa.parent_phone ? "  •  " + siswa.parent_phone : ""}`, LEFT_VAL_X, y);
    y += 5.5;
  }

  y += 1;
  doc.setDrawColor(230, 230, 230);
  doc.line(14, y, W - 12, y);

  // === Untuk Pembayaran ===
  y += 6;
  doc.setTextColor(140, 140, 140);
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.text("UNTUK PEMBAYARAN", 14, y);

  y += 5;
  doc.setTextColor(30, 30, 30);
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  const nomLabel = nomenklatur ? `${nomenklatur.code} — ${nomenklatur.name}` : payment.nomenklatur_code;
  doc.text(nomLabel, 14, y);
  if (payment.note) {
    y += 4.5;
    doc.setFontSize(7);
    doc.setFont("helvetica", "italic");
    doc.setTextColor(100, 100, 100);
    doc.text(String(payment.note).slice(0, 80), 14, y);
  }

  // === Amount Box (right) ===
  const boxY = 73;
  doc.setFillColor(240, 253, 250); // teal-50
  doc.setDrawColor(11, 141, 149);
  doc.setLineWidth(0.5);
  doc.roundedRect(W - 82, boxY, 70, 22, 2, 2, "FD");
  doc.setTextColor(11, 141, 149);
  doc.setFontSize(6.5);
  doc.setFont("helvetica", "normal");
  doc.text("JUMLAH DIBAYAR", W - 47, boxY + 5, { align: "center" });
  doc.setFontSize(15);
  doc.setFont("helvetica", "bold");
  doc.text(fmtIDR(payment.amount), W - 47, boxY + 13, { align: "center" });
  // Status pill
  const status = tagihan_sisa === 0 ? "LUNAS" : (tagihan_sisa > 0 ? `SISA ${fmtIDR(tagihan_sisa)}` : "DITERIMA");
  const statusColor = tagihan_sisa === 0 ? [16, 185, 129] : (tagihan_sisa > 0 ? [245, 158, 11] : [11, 141, 149]);
  doc.setFillColor(...statusColor);
  const statusW = doc.getTextWidth(status) + 6;
  doc.roundedRect(W - 47 - statusW / 2, boxY + 15.5, statusW, 5, 1, 1, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(6.5);
  doc.setFont("helvetica", "bold");
  doc.text(status, W - 47, boxY + 19, { align: "center" });

  // === Terbilang (indent ke kanan agar tidak tumpang tindih QR di kiri) ===
  const terY = boxY + 26;
  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.3);
  doc.line(14, terY, W - 12, terY);
  const terX = 36; // indent kanan QR
  doc.setTextColor(140, 140, 140);
  doc.setFontSize(6.5);
  doc.setFont("helvetica", "normal");
  doc.text("TERBILANG", terX, terY + 5);
  doc.setTextColor(40, 40, 40);
  doc.setFontSize(8);
  doc.setFont("helvetica", "italic");
  const terbilangText = "# " + terbilang(payment.amount) + " #";
  const terbilangLines = doc.splitTextToSize(terbilangText, W - terX - 60);
  doc.text(terbilangLines, terX, terY + 10);

  // === Footer signature (tanpa garis bawah nama) ===
  const sigY = H - 22;
  doc.setTextColor(90, 90, 90);
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  const cityDate = `${settings?.city || "Bandung"}, ${fmtDate(payment.payment_date)}`;
  doc.text(cityDate, W - 42, sigY + 3, { align: "center" });
  const bendaharaName = settings?.signatory_bendahara || "";
  doc.setTextColor(30, 30, 30);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text(bendaharaName || "( ......................... )", W - 42, sigY + 10, { align: "center" });
  doc.setTextColor(120, 120, 120);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.text("Bendahara Sekolah", W - 42, sigY + 14, { align: "center" });

  // === Left footer (mini legalese) ===
  doc.setTextColor(160, 160, 160);
  doc.setFontSize(6);
  doc.text("Kwitansi ini sah tanpa tanda tangan basah bila diterbitkan melalui sistem EduFoundation.", 14, H - 6);

  // === QR Code (verifikasi keaslian) — kiri bawah, ukuran kecil, resolusi tinggi ===
  try {
    const qrPayload = [
      `KWITANSI ${payment.receipt_no || "-"}`,
      `${siswa?.name || "-"} (${siswa?.nis || "-"})`,
      `${fmtIDR(payment.amount)} - ${payment.payment_date || "-"}`,
      `${lembaga?.name || "-"}`,
    ].join("\n");
    const qrDataUrl = await QRCode.toDataURL(qrPayload, {
      margin: 2,                    // quiet zone (wajib agar bisa di-scan)
      width: 400,                   // resolusi tinggi agar tetap tajam saat dicetak kecil
      errorCorrectionLevel: "M",
    });
    const qrSize = 20;
    const qrX = 12;
    const qrY = terY - 2; // sejajar dengan terbilang, di kiri
    doc.addImage(qrDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
    doc.setTextColor(120, 120, 120);
    doc.setFontSize(5.5);
    doc.setFont("helvetica", "normal");
    doc.text("Scan untuk verifikasi", qrX + qrSize / 2, qrY + qrSize + 3, { align: "center" });
  } catch (_) { /* silent - QR optional */ }

  return doc;
}

// ==========================================================
// Kwitansi Pengeluaran (A5 landscape) — bukti pengeluaran kas
// ==========================================================
export async function generateExpenseReceiptPDF({ expense, lembaga, nomenklatur, settings }) {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a5" });
  const W = 210, H = 148;

  // Rose accent for pengeluaran (distinct from income teal)
  doc.setFillColor(220, 38, 38);
  doc.rect(0, 0, 7, H, "F");

  doc.setTextColor(220, 38, 38);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text((settings?.foundation_short_name || settings?.foundation_name || "EduFoundation").toUpperCase(), 14, 12);
  doc.setFontSize(7);
  doc.setTextColor(120, 120, 120);
  doc.setFont("helvetica", "normal");
  doc.text(settings?.foundation_name || "Yayasan EduFoundation", 14, 16);
  if (settings?.address) doc.text(String(settings.address).slice(0, 60), 14, 19.5);

  doc.setFillColor(220, 38, 38);
  doc.roundedRect(W - 62, 8, 50, 17, 2, 2, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("BUKTI PENGELUARAN", W - 37, 15, { align: "center" });
  doc.setFontSize(8);
  doc.text(expense.receipt_no || "-", W - 37, 21, { align: "center" });

  doc.setDrawColor(230, 230, 230);
  doc.setLineWidth(0.3);
  doc.line(14, 30, W - 12, 30);

  let y = 37;
  const rows = [
    ["Tanggal", fmtDate(expense.expense_date), "Nomenklatur", `${expense.nomenklatur_code || "-"}${nomenklatur ? " – " + nomenklatur.name : ""}`],
    ["Lembaga", lembaga?.name || "Yayasan (Umum)", "Kategori", expense.category || "-"],
    ["Dibayar Kepada", expense.vendor || expense.paid_to || "-", "No. Bukti", expense.receipt_no || "-"],
  ];
  rows.forEach(([l1, v1, l2, v2]) => {
    doc.setTextColor(140, 140, 140);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7.5);
    doc.text(l1, 14, y); doc.text(l2, 112, y);
    doc.setTextColor(30, 30, 30);
    doc.setFont("helvetica", "bold");
    doc.text(String(v1), 44, y); doc.text(String(v2), 145, y);
    y += 5.5;
  });

  y += 2;
  doc.setDrawColor(230, 230, 230);
  doc.line(14, y, W - 12, y);
  y += 6;
  doc.setTextColor(140, 140, 140);
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.text("URAIAN PENGELUARAN", 14, y);
  y += 5;
  doc.setTextColor(30, 30, 30);
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  const descLines = doc.splitTextToSize(expense.description || "-", 120);
  doc.text(descLines, 14, y);

  const boxY = 73;
  doc.setFillColor(254, 226, 226);
  doc.setDrawColor(220, 38, 38);
  doc.setLineWidth(0.5);
  doc.roundedRect(W - 82, boxY, 70, 22, 2, 2, "FD");
  doc.setTextColor(220, 38, 38);
  doc.setFontSize(6.5);
  doc.setFont("helvetica", "normal");
  doc.text("JUMLAH PENGELUARAN", W - 47, boxY + 5, { align: "center" });
  doc.setFontSize(15);
  doc.setFont("helvetica", "bold");
  doc.text(fmtIDR(expense.amount), W - 47, boxY + 15, { align: "center" });

  const terY = boxY + 26;
  doc.line(14, terY, W - 12, terY);
  doc.setTextColor(140, 140, 140);
  doc.setFontSize(6.5);
  doc.setFont("helvetica", "normal");
  doc.text("TERBILANG", 14, terY + 5);
  doc.setTextColor(40, 40, 40);
  doc.setFontSize(8);
  doc.setFont("helvetica", "italic");
  const t = doc.splitTextToSize("# " + terbilang(expense.amount) + " #", W - 30);
  doc.text(t, 14, terY + 10);

  const sigY = H - 22;
  doc.setTextColor(90, 90, 90);
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.text(`Bandung, ${fmtDate(expense.expense_date)}`, W - 42, sigY + 3, { align: "center" });
  doc.setTextColor(120, 120, 120);
  doc.text("( ......................... )", W - 42, sigY + 10, { align: "center" });
  doc.setTextColor(30, 30, 30);
  doc.setFont("helvetica", "bold");
  doc.text("Manager Keuangan", W - 42, sigY + 14, { align: "center" });

  doc.setTextColor(160, 160, 160);
  doc.setFontSize(6);
  doc.text("Bukti pengeluaran diterbitkan otomatis oleh sistem EduFoundation.", 14, H - 6);

  // QR verifikasi
  try {
    const qrPayload = `EduFoundation PENGELUARAN\nNo: ${expense.receipt_no || "-"}\nTgl: ${expense.expense_date}\nNomen: ${expense.nomenklatur_code}\nJumlah: ${fmtIDR(expense.amount)}`;
    const qrUrl = await QRCode.toDataURL(qrPayload, { margin: 0, width: 200 });
    doc.addImage(qrUrl, "PNG", 14, H - 40, 22, 22);
    doc.setTextColor(120, 120, 120);
    doc.setFontSize(5.5);
    doc.text("Scan untuk verifikasi", 25, H - 15, { align: "center" });
  } catch (_) { /* silent */ }

  return doc;
}

export async function downloadExpenseReceipt(args) {
  const doc = await generateExpenseReceiptPDF(args);
  doc.save(`bukti-pengeluaran-${args.expense.receipt_no || Date.now()}.pdf`);
}

// ==========================================================
// SLIP GAJI (A4 portrait — 1 halaman profesional per guru)
// ==========================================================
export function generateSlipPDF({ slip, employee, lembaga, penerimaan_defs, potongan_defs, settings, period_label }) {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const W = 210, H = 297;

  // Header teal band
  doc.setFillColor(11, 141, 149);
  doc.rect(0, 0, W, 32, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.text((settings?.foundation_short_name || settings?.foundation_name || "EDUFOUNDATION").toUpperCase(), 15, 14);
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  if (settings?.foundation_name) doc.text(settings.foundation_name, 15, 19);
  if (settings?.address) doc.text(String(settings.address).slice(0, 80), 15, 23);
  if (settings?.phone || settings?.email) doc.text(`${settings.phone || ""} · ${settings.email || ""}`.trim(), 15, 27);

  // Right side title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("SLIP GAJI KARYAWAN", W - 15, 15, { align: "right" });
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text(`Periode: ${period_label || slip.period}`, W - 15, 22, { align: "right" });
  doc.text(`No: ${employee?.employee_id || "-"}`, W - 15, 27, { align: "right" });

  // Employee info box
  let y = 42;
  doc.setDrawColor(230, 230, 230);
  doc.setFillColor(248, 250, 251);
  doc.roundedRect(15, y, W - 30, 24, 2, 2, "FD");
  doc.setTextColor(100, 100, 100);
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  const info = [
    ["Nama", employee?.name || "-", "Jabatan", employee?.position || "-"],
    ["ID Karyawan", employee?.employee_id || "-", "Lembaga", lembaga?.name || "-"],
    ["Status", (employee?.status || "aktif").toUpperCase(), "Tanggal Cetak", new Date().toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" })],
  ];
  info.forEach(([l1, v1, l2, v2], i) => {
    const yy = y + 6 + i * 6;
    doc.setTextColor(140, 140, 140);
    doc.setFont("helvetica", "normal");
    doc.text(l1, 20, yy); doc.text(l2, 115, yy);
    doc.setTextColor(30, 30, 30);
    doc.setFont("helvetica", "bold");
    doc.text(String(v1), 45, yy); doc.text(String(v2), 145, yy);
  });

  y += 32;
  // Two column layout: Penerimaan | Potongan
  const colW = (W - 40) / 2;
  const p_items = penerimaan_defs.filter((c) => Number(slip.penerimaan_items?.[c.key] || 0) > 0);
  const d_items = potongan_defs.filter((c) => Number(slip.potongan_items?.[c.key] || 0) > 0);
  const nRows = Math.max(p_items.length, d_items.length, 3);

  // Penerimaan column
  doc.setFillColor(220, 252, 231);
  doc.rect(15, y, colW, 7, "F");
  doc.setTextColor(16, 122, 63);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("PENERIMAAN", 18, y + 5);

  // Potongan column
  doc.setFillColor(254, 226, 226);
  doc.rect(15 + colW + 10, y, colW, 7, "F");
  doc.setTextColor(159, 18, 57);
  doc.text("POTONGAN", 18 + colW + 10, y + 5);

  y += 10;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  for (let i = 0; i < nRows; i++) {
    if (p_items[i]) {
      doc.setTextColor(60, 60, 60);
      doc.text(p_items[i].label, 18, y);
      doc.setTextColor(30, 30, 30);
      doc.setFont("helvetica", "bold");
      doc.text(fmtIDR(slip.penerimaan_items[p_items[i].key]), 15 + colW - 3, y, { align: "right" });
      doc.setFont("helvetica", "normal");
    }
    if (d_items[i]) {
      doc.setTextColor(60, 60, 60);
      doc.text(d_items[i].label, 18 + colW + 10, y);
      doc.setTextColor(30, 30, 30);
      doc.setFont("helvetica", "bold");
      doc.text(fmtIDR(slip.potongan_items[d_items[i].key]), 15 + 2 * colW + 7, y, { align: "right" });
      doc.setFont("helvetica", "normal");
    }
    y += 5.5;
  }

  y += 3;
  // Subtotals
  doc.setDrawColor(200, 200, 200);
  doc.line(15, y - 2, 15 + colW, y - 2);
  doc.line(15 + colW + 10, y - 2, 15 + 2 * colW + 10, y - 2);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(16, 122, 63);
  doc.text("Total Penerimaan", 18, y + 3);
  doc.text(fmtIDR(slip.total_penerimaan), 15 + colW - 3, y + 3, { align: "right" });
  doc.setTextColor(159, 18, 57);
  doc.text("Jumlah Potongan", 18 + colW + 10, y + 3);
  doc.text(fmtIDR(slip.total_potongan), 15 + 2 * colW + 7, y + 3, { align: "right" });

  // Take Home Pay box
  y += 12;
  doc.setFillColor(11, 141, 149);
  doc.roundedRect(15, y, W - 30, 22, 3, 3, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("TAKE HOME PAY", 20, y + 8);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text(fmtIDR(slip.take_home_pay), W - 20, y + 12, { align: "right" });
  doc.setFontSize(8);
  doc.setFont("helvetica", "italic");
  doc.text(`# ${terbilang(slip.take_home_pay)} #`, 20, y + 18);

  // Rekening
  y += 28;
  doc.setDrawColor(230, 230, 230);
  doc.setFillColor(248, 250, 251);
  doc.roundedRect(15, y, W - 30, 18, 2, 2, "FD");
  doc.setTextColor(140, 140, 140);
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.text("TRANSFER KE", 20, y + 6);
  doc.text("NOMOR REKENING", 80, y + 6);
  doc.text("ATAS NAMA", 140, y + 6);
  doc.setTextColor(30, 30, 30);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text(slip.rekening_bank || "Bank Syariah Indonesia", 20, y + 12);
  doc.text(slip.rekening_no || "-", 80, y + 12);
  doc.text(slip.rekening_name || employee?.name || "-", 140, y + 12);

  if (slip.note) {
    y += 24;
    doc.setTextColor(140, 140, 140);
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("CATATAN", 15, y);
    y += 4;
    doc.setTextColor(60, 60, 60);
    doc.setFont("helvetica", "italic");
    doc.text(doc.splitTextToSize(String(slip.note), W - 30), 15, y);
  }

  // Signature footer — Slip Gaji: TTD hanya Manager Keuangan (single, kanan)
  const sigY = H - 45;
  doc.setTextColor(60, 60, 60);
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text(`${settings?.city || "Bandung"}, ${new Date().toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" })}`, W - 15, sigY, { align: "right" });
  doc.text("Manager Keuangan,", W - 25, sigY + 8, { align: "right" });
  const mgrName = settings?.signatory_manager_keuangan || "";
  doc.setFontSize(9);
  doc.setTextColor(30, 30, 30);
  doc.setFont("helvetica", "bold");
  doc.text(mgrName || "( ..................................... )", W - 25, sigY + 28, { align: "right" });
  doc.setFontSize(8);
  doc.setTextColor(120, 120, 120);
  doc.setFont("helvetica", "normal");
  doc.text("Manager Keuangan", W - 25, sigY + 33, { align: "right" });

  doc.setTextColor(160, 160, 160);
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.text("Slip gaji ini diterbitkan otomatis oleh sistem EduFoundation dan sah tanpa tanda tangan basah.", 15, H - 8);

  return doc;
}

export function downloadSlipPDF(args) {
  const doc = generateSlipPDF(args);
  doc.save(`slip-gaji-${args.employee?.employee_id || "karyawan"}-${args.slip.period}.pdf`);
}

// Download the receipt PDF
export async function downloadReceipt(args) {
  const doc = await generateReceiptPDF(args);
  const emp = args.siswa?.name?.replace(/\s+/g, "_") || "siswa";
  doc.save(`kwitansi-${args.payment.receipt_no || emp}.pdf`);
}

// Normalize Indonesian phone number to international format (62xxx, digits only)
export function normalizePhoneID(raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("62")) return digits;
  if (digits.startsWith("0")) return "62" + digits.slice(1);
  if (digits.startsWith("8")) return "62" + digits;
  return digits;
}

// Build WhatsApp URL universal (wa.me — buka di WA Web atau WA Desktop/Mobile)
// Text-only, tanpa attachment PDF. Untuk kwitansi PDF, pakai tombol "Cetak".
export function buildWhatsAppReceiptURL({ payment, siswa, lembaga, nomenklatur, settings, tagihan_sisa }) {
  const normalized = normalizePhoneID(siswa?.parent_phone);
  const fname = settings?.foundation_short_name || settings?.foundation_name || "Yayasan";
  const statusLine = tagihan_sisa === 0 ? "✅ *LUNAS*" : (tagihan_sisa > 0 ? `⚠️ Sisa tagihan: ${fmtIDR(tagihan_sisa)}` : "");
  const lines = [
    `*KWITANSI PEMBAYARAN*`,
    `_${fname}_`,
    ``,
    `No. Kwitansi: *${payment.receipt_no || "-"}*`,
    `Tanggal: ${fmtDate(payment.payment_date)}`,
    ``,
    `👤 Siswa: *${siswa?.name || "-"}*`,
    `NIS: ${siswa?.nis || "-"}${siswa?.nisn ? " · NISN: " + siswa.nisn : ""}`,
    `Kelas: ${siswa?.class_name || "-"}`,
    `Lembaga: ${lembaga?.name || "-"}`,
    ``,
    `📌 Untuk: *${nomenklatur ? nomenklatur.code + " – " + nomenklatur.name : payment.nomenklatur_code}*`,
    `Metode: ${(payment.method || "-").toUpperCase()}`,
    ``,
    `💰 *${fmtIDR(payment.amount)}*`,
    `(${terbilang(payment.amount)})`,
    statusLine,
    ``,
    `Terima kasih atas pembayarannya. 🙏`,
    `— ${fname}`,
  ].filter(Boolean);
  const text = encodeURIComponent(lines.join("\n"));
  // wa.me — universal link:
  // - Buka di aplikasi WhatsApp Desktop kalau terpasang
  // - Fallback ke web.whatsapp.com kalau tidak
  // - Di mobile langsung buka aplikasi WA
  if (normalized) {
    return `https://wa.me/${normalized}?text=${text}`;
  }
  return `https://wa.me/?text=${text}`;
}
